import type { Response } from '~/types/api/v2'

import type { WorkspaceIdentifier } from '../types'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

export const responseDataTypeName: App.Data.PurchasedTemplateData['_data_type'] = 'purchased_template_data'

export const useFetchPurchasedTemplates = () => {
  const { get, post, deleteRequest } = useFetchWithDefaults()

  const getAll = ({ workspaceId }: WorkspaceIdentifier) => get<Response<App.Data.PurchasedTemplateData[]>>({
    url: '/v2/purchased-templates',
    workspaceId,
  })

  const purchase = async ({ templateId, workspaceId }: { templateId: string } & WorkspaceIdentifier) =>
    post<Response<App.Data.PurchasedTemplateData>>({
      url: `/v2/purchased-templates`,
      workspaceId,
      fetchOptions: {
        body: {
          templateId,
        } satisfies App.Data.Payloads.PurchaseTemplatePayload,
      },
    })

  const drop = ({ id, workspaceId }: { id: string } & WorkspaceIdentifier) => deleteRequest({
    url: `/v2/purchased-templates/${id}`,
    workspaceId,
  })

  return {
    getAll,
    purchase,
    drop,
  }
}
